module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Pu3Wji/tc-custom/9781913682446.jpg?1737687886918",
      "alt": "This image is the cover for the book Doll Collector"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Doll Collector\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Her dolls are on display, but her crimes are hidden—until the façade begins to crack . . .")]), _c('br'), _c('br'), _vm._v(" A couple and their young son burn to death in a house fire. A girl dies from a nut allergy. A woman falls under a train during rush hour. An accountant falls down the steps to his basement."), _c('br'), _c('br'), _vm._v(" Their deaths appear to be accidents, but Gloria knows they were murdered. Because she murdered them. And every time Gloria kills, she buys a doll."), _c('br'), _vm._v(" But how many dolls will she need to keep her satisfied?"), _c('br'), _c('br'), _vm._v(" Gloria craves love and happiness and friendship, and will do anything to get what she craves. But now her behavior is spinning out of control, in this dark, compelling thriller.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joanna Stephen-Ward\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0